import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {
    MedicalRecordGeneralInformationRepository
} from './impl/service/ngrx/medicalRecordGeneralInformation.repository';
import {
    MedicalRecordGeneralInformationDataService
} from './impl/service/ngrx/medicalRecordGeneralInformationData.service';

@NgModule({
})
export class MedicalRecordGeneralInformationModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: MedicalRecordGeneralInformationDataService,
                service: MedicalRecordGeneralInformationRepository,
    ) {

        entityDataService.registerServices({
            MedicalRecordGeneralInformation: dataService,
        });

        entityServices.registerEntityCollectionServices({
            MedicalRecordGeneralInformation: service,
        });


    }
}
